// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__4HSsT","head":"ProcedureTableInfo_head__2o2gm"};